import React from 'react';
import { TooltipProps } from '@material-ui/core/Tooltip';
import { Tooltip } from '@material-ui/core';

export const TooltipWrapper = (props: TooltipProps) => {
    return props.title ? <Tooltip {...props} /> : props.children;
};
